import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Category as View } from 'ui-components/components/molecules/Visualization/Category'
import { LAYER_TYPES, setLayerType } from '~map-preview/states/layerType'
import { useCategoryOptions } from '~map-preview/states/map'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { MARKER_TYPES, setCategory, setType } from '~map-preview/states/marker'
import { openMapLegend } from '~map-preview/states/ui'
import { Category as TypeCategory } from '~map-preview/types/__generated/gql/graphql'

export const Category = () => {
  const dispatch = useDispatch()
  const { visualization, setVisualization } = useMapToolbarStore()
  const options = useCategoryOptions()

  useEffect(() => {
    if (visualization) {
      const selected: TypeCategory | undefined =
        visualization &&
        (Object.values(visualization)[0] as TypeCategory | undefined)

      if (selected?.id === 'category') {
        dispatch(setLayerType(LAYER_TYPES.MARKER))
        dispatch(setType(MARKER_TYPES.CATEGORIES))
        dispatch(openMapLegend())
        dispatch(setCategory(selected?.property || options[0]?.value))
      }
    }
  }, [visualization])

  const handleChange = (event) => {
    const tmp = { ...visualization }
    if (tmp['category']) {
      tmp['category']['property'] = event.target.value
    }
    setVisualization(tmp)
  }

  const selected: TypeCategory | undefined =
    visualization &&
    (Object.values(visualization)[0] as TypeCategory | undefined)

  if (options.length === 0) return null

  return (
    <View
      value={selected?.property || options[0]?.value}
      options={options}
      onChange={handleChange}
    />
  )
}
